import Home from "./pages/Home";

export default function App() {
  return (
    <main className="">
      <Home />
      {/* <Footer  /> */}
    </main>
  );
}
